module.exports = __webpack_public_path__ + "static/media/app-icon.b7a79bb1.png";